// components/DebouncedInput.jsx
import React, { useState, useRef, useEffect } from "react";

export default function DebouncedInput({
  name,
  value = "",
  onSave,                // parent passes the API handler
  delay = 600,
  disabled = false,
  highlightCondition,
  isDeniedOrPartial
}) {
  const [inputValue, setInputValue] = useState(value);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(async () => {
      if (onSave) await onSave(newValue, name);
    }, delay);
  };

  return (
    <input
      type="text"
      value={inputValue}
      disabled={disabled}
      onChange={handleChange}
      style={{
        width: "70px",
        borderRadius: "5px",
        borderColor: "lightgray",

        backgroundColor: (name === "RecvdCharge" || name === "SecrecvdCharge") &&
          inputValue !== "" &&
          Number(inputValue) === 0
          ? "red"
          : highlightCondition
            ? name === "PatientAmount"
              ? "lightgray"
              : "lightgreen"
            : "white",
      }}
      className="input"
    />
  );
}
